import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckupComponent } from './checkup.component';

const routes: Routes = [
  {
    path: '',
    component: CheckupComponent,
  },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
